// libs
import head from 'lodash/head';

import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { ResourceTypeEnum } from '@/types/schema';

// types
import { CertificateSettingsOptions } from './types';

export const getCertificateSettingsItems = ({
  t,
  disableLinkedInSharing,
  disableSocialSharing,
}: {
  t: TFunction;
  disableLinkedInSharing: boolean;
  disableSocialSharing: boolean;
}) =>
  getEnabledItems([
    {
      id: CertificateSettingsOptions.AllowLinkedinProfile,
      label: t('Certificate:Form.AddToLinkedInTitle'),
      description: t('Certificate:Form.AddToLinkedInDescription'),
      enabled: !disableLinkedInSharing,
    },
    {
      id: CertificateSettingsOptions.AllowSocialSharing,
      label: t('Certificate:Form.SocialSharingTitle'),
      description: t('Certificate:Form.SocialSharingDescription'),
      enabled: !disableSocialSharing,
    },
    {
      id: CertificateSettingsOptions.AllowDownload,
      label: t('Certificate:Form.DownloadPdfTitle'),
      description: t('Certificate:Form.DownloadPdfDescription'),
      enabled: true,
    },
  ]) as {
    id: Exclude<CertificateSettingsOptions, CertificateSettingsOptions.MinPercentage>;
    label: string;
    description: string;
  }[];

export const getCertificateCondition = (t: TFunction, contentType?: ResourceTypeEnum | 'EVENT') => {
  return head(
    getEnabledItems([
      {
        id: 'minPercentage',
        label: t('Certificate:Form.RequireMinimumScore'),
        description: t('Certificate:Form.RequireMinimumScoreDescription'),
        placeholder: t('Certificate:Form.RequireMinimumScorePlaceholder'),
        enabled: contentType === ResourceTypeEnum.Exercise,
      },
      // {
      //   id: 'minPercentage',
      //   label: t('Certificate:Form.RequireMinimumMastery'),
      //   description: t('Certificate:Form.RequireMinimumMasteryDescription'),
      //   placeholder: t('Certificate:Form.RequireMinimumScorePlaceholder'),
      //   enabled: contentType === ResourceTypeEnum.Course,
      // },
      {
        id: 'minPercentage',
        label: t('Certificate:Form.RequireMinimumAttendance'),
        description: t('Certificate:Form.RequireMinimumAttendanceDescription'),
        placeholder: t('Certificate:Form.RequireMinimumAttendancePlaceholder'),
        enabled: contentType === 'EVENT',
      },
    ]),
  );
};
